import * as React from 'react';

import { EShop } from '@containers/App/model';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';
import { styled } from '@linaria/react';

import { getIconsByCountry } from './utils';

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;

  margin-bottom: 2.25rem;

  svg {
    width: 40px;
    height: 40px;
  }
`;

const PaymentMethods = () => {
  const { shopId } = useApolloClientHeaders();
  const icons = getIconsByCountry(shopId as EShop);

  if (icons.length === 0) {
    return null;
  }

  return <IconWrapper>{icons}</IconWrapper>;
};

export default PaymentMethods;
